import { AlertTriangle } from 'lucide-react'
import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  appliesToOnlyLabel,
  countedContactType,
  customFieldAppliesToLabel,
} from '@/lib/contacts/labels'
import type {
  CustomField,
  CustomFieldNarrowingWarning,
  CustomFieldSetupForm,
} from '@/lib/contacts/types'

export function NarrowCustomFieldDialog({
  field,
  form,
  warning,
  pending,
  onCancel,
  onConfirm,
}: {
  field: CustomField
  form: CustomFieldSetupForm
  warning: CustomFieldNarrowingWarning
  pending: boolean
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Narrow "{field.label}" to {appliesToOnlyLabel(form.appliesTo)}?
          </DialogTitle>
          <DialogDescription>
            It currently applies to {customFieldAppliesToLabel(field.applies_to)}.
          </DialogDescription>
        </DialogHeader>
        <Alert variant="warning" className="flex items-start gap-2">
          <AlertTriangle
            className="mt-0.5 h-4 w-4 shrink-0 text-warning"
            strokeWidth={1.5}
            aria-hidden="true"
          />
          <span>
            Its value on{' '}
            <span className="font-medium">
              {warning.deleted_value_count} {countedContactType(warning)}
            </span>{' '}
            will be deleted. Widening the field later will not restore deleted values.
          </span>
        </Alert>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" disabled={pending} onClick={onConfirm}>
            Narrow field
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
